import { render, staticRenderFns } from "./HelpFindGoodsDetail.vue?vue&type=template&id=565c10fb&scoped=true&"
import script from "./HelpFindGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./HelpFindGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./HelpFindGoodsDetail.vue?vue&type=style&index=0&id=565c10fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c10fb",
  null
  
)

export default component.exports